module.exports = __webpack_public_path__ + "static/media/fav_benner.98811e85.svg";